import React from 'react';

function ArrowUpCircle({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M11 20.1667C16.0626 20.1667 20.1667 16.0627 20.1667 11C20.1667 5.93743 16.0626 1.83337 11 1.83337C5.9374 1.83337 1.83334 5.93743 1.83334 11C1.83334 16.0627 5.9374 20.1667 11 20.1667Z" />
      <path d="M14.6667 11L11 7.33337L7.33334 11" />
      <path d="M11 14.6667V7.33337" />
    </svg>
  );
}

export default ArrowUpCircle;
